import {
  createFileRoute,
  Outlet,
  retainSearchParams,
} from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useMemo } from "react";

import { PilotFlowHydration } from "@/features/Generations/components/PilotFlowHydration";
import { PilotStateProvider } from "@/features/Generations/context/PilotStateContext";
import {
  pilotFlowSearchSchema,
  searchKeys,
} from "@/features/Generations/flowSearch";
import {
  productCardsFilterForPilotGroup,
  productGroupForPilotGroup,
} from "@/features/Generations/pilotFlowGroup";

export const Route = createFileRoute("/_auth/generations/$siteId/new/pilot")({
  component: RouteComponent,
  validateSearch: zodValidator(pilotFlowSearchSchema),
  search: {
    middlewares: [retainSearchParams(searchKeys(pilotFlowSearchSchema))],
  },
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const { propagationId, groupName, groupType, groupId, allProducts } =
    Route.useSearch();

  const taxonomyFilter = useMemo(
    () =>
      productCardsFilterForPilotGroup({ groupName, groupType, allProducts }),
    [groupName, groupType, allProducts],
  );
  const productGroup = useMemo(
    () =>
      productGroupForPilotGroup({
        groupName,
        groupType,
        groupId: groupId?.toString(),
        allProducts,
      }),
    [groupName, groupType, groupId, allProducts],
  );

  return (
    <PilotStateProvider initialState={{ taxonomyFilter, productGroup }}>
      <PilotFlowHydration siteId={siteId} propagationSlug={propagationId} />
      <Outlet />
    </PilotStateProvider>
  );
}
